module.exports = __webpack_public_path__ + "e070715cfb820945b27fdd84068ef9ce.woff";